import InternalAdPaywall from "components/ads/InternalAdPaywall";
import { useSeeHint } from "components/hint/Hint";
import React, { useState } from "react";
import styled from "styled-components/macro";
import { logEvent, PROXY } from "tools/analyticEvents";
import { useViewerQuery } from "queries/viewerQuery";
import TrialSubscriptionGift from "../onboarding/TrialSubscriptionGift";
import { useEffectOnce } from "react-use";
import { useSetLastImpulse } from "hooks/useSetLastImpulse";
import { useSaleExpiration } from "root/profile/subscription/subscriptionHooks";
import { useSetState } from "components/ReduxProvider";
import { SALE } from "sharedJs__generated/constants";

export const FIRSTSUBSCRIPTION = "firstSubscription";

const Wrap = styled.div`
  position: absolute;
  z-index: 1000;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: ${({ theme }) => theme.duo.maxWidth.normal};
  width: 100%;
  background: ${({ theme }) => theme.duo.color.lightGrey};
`;

const FirstSubscription: React.FC<{ onRequestSubmit: () => void }> = ({ onRequestSubmit }) => {
  const seeHint = useSeeHint();
  const { isSubscriber, subscriptionFlags } = useViewerQuery();
  const [showGift, setShowGift] = useState(false);
  const setLastSeen = useSetState("saleMainDialogLastSeen");
  const { saleId } = useSaleExpiration();
  const setLastImpulse = useSetLastImpulse();

  useEffectOnce(() => {
    setLastImpulse("onboarding1");
  });

  const handleClose = () => {
    logEvent(PROXY.email_set); // moved two screens further to optimize campaigns better
    seeHint(FIRSTSUBSCRIPTION);

    if (saleId === SALE.blackFriday) {
      setLastSeen(SALE.blackFriday);
    }

    if (isSubscriber && subscriptionFlags.hasActiveFamilySub) {
      setShowGift(true);
    } else {
      onRequestSubmit();
    }
  };

  return (
    <Wrap>
      {showGift ? <TrialSubscriptionGift onSubmit={onRequestSubmit} /> : <InternalAdPaywall onClose={handleClose} />}
    </Wrap>
  );
};

export default FirstSubscription;
